/* eslint-disable import/first */
import React from 'react';
import { useLocation, useNavigate } from '@reach/router';
import { HiChevronRight } from '@react-icons/all-files/hi/HiChevronRight';
import css from './index.module.scss';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import { FormattedMessage } from 'react-intl';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
import classNames from 'classnames';
const { useSelector, useDispatch } = Redux;
const { selectCountryValidations } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { updateProductPayload } = Slices.tempCartSlice;
const { selectProductEntities } = Slices.productSlice;
const { selectCartCount } = Slices.cartSlice;
import addIcon from '../ProductTileList/images/icAddToCart.svg';
import CartItemCount from './CartItemCount';
import noImg from '../../assets/no-itm.png';
import enabledCartBag from '../../containers/Deal/images/cartBag.svg';

export default function ViewCartButton({
  onClick,
  buttonText,
  showIcon = true,
  to,
  amount,
  currency = 'AED',
  isBundleItem,
  selectedProduct,
  categoryID,
  productID,
  showCustomizeProductDialog,
  imgSrc,
  isDesktop,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const productsMap = useSelector(selectProductEntities);

  const bogoProducts = useSelector((state) => state.product.bogoProdList);

  const locationSearch = new URLSearchParams(location.search);
  const stepId = locationSearch.get('step');
  const mainProductId = locationSearch.get('main_product');
  const count = useSelector(selectCartCount);

  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));

  const tempItems = useSelector((state) => state.tempCart);

  const productCustomization = tempItems.data.items?.find((item) => item.id == mainProductId) || {};

  const handleNavigation = (e) => {
    const newProductCust = JSON.parse(JSON.stringify(productCustomization));
    if (isBundleItem) {
      if (newProductCust?.bundle?.[stepId]?.[productID]?.notAdded) {
        delete newProductCust['bundle'][stepId][productID]['notAdded'];
      }
      const addedProducts = Object.values(newProductCust['bundle'] || {}).length;
      const qtyInfo = addedProducts > 0 ? { addedProducts: addedProducts } : {};
      if (productsMap[mainProductId]?.isBOGO) {
        newProductCust.bundle[stepId][productID]['price'] = amount;
      }
      localStorage.setItem('isBackNotPressed', true);

      let bogoPrice = 0;
      if (productsMap[mainProductId]?.isBOGO) {
        const items = [];

        for (let step of Object.values(productCustomization?.bundle || {})) {
          const itemId = Object.keys(step)[0];
          const itemCustomization = Object.values(step)[0];

          const optionId = parseInt(locationSearch.get('option'));
          let productObj = productsMap[productCustomization]?.items
            ?.find((item) => item?.id == optionId)
            ?.steps?.[0]?.options?.find((option) => option?.id == itemId);

          if (!productObj) {
            productObj = bogoProducts[optionId]?.find((option) => option?.id == itemId);
          }

          let itemInfo;
          let selectedItemIndex = -1;

          if ((productObj?.items?.length || 0) < 2 || productObj?.typeId == 'simple') {
            selectedItemIndex = 0;
          } else {
            let variationArray = [-1, -1, -1];

            if (Object.values(itemCustomization?.variants || {}).length > 0) {
              Object.values(itemCustomization?.variants || {}).forEach((variant, index) => {
                variationArray[index] = variant;
              });
            } else {
              Object.values(productObj?.variants || {}).forEach((variant, index) => {
                const selectedOption = variant?.options?.find((option) => option?.isSelected == 1);
                if (selectedOption) {
                  variationArray[index] = selectedOption?.id;
                }
              });
            }

            productObj.items.forEach((item, i) => {
              let areVariationsSame = true;
              variationArray.forEach((value, index) => {
                if (item[`sel${index + 1}Value`] != value) {
                  areVariationsSame = false;
                }
              });

              if (areVariationsSame) {
                selectedItemIndex = i;
              }
            });
          }

          itemInfo = productObj?.items?.[selectedItemIndex];
          if (!itemInfo?.steps?.options) {
            itemInfo =
              productsMap[productObj?.id]?.items?.find((item) => item?.id == itemInfo?.id) ||
              productObj?.items[selectedItemIndex] ||
              itemInfo;
          }
          if (!itemInfo?.id) {
            itemInfo = productsMap[itemInfo];
          }

          let basePrice = 0;
          basePrice +=
            itemInfo?.price >= 0
              ? itemInfo?.price
              : itemInfo?.specialPrice || itemInfo?.originalPrice || 0;

          let extraPrice = 0;

          for (let step of itemInfo?.steps || []) {
            for (let option of step?.options || []) {
              if (option?.subOptions) {
                extraPrice +=
                  option?.subOptions[itemCustomization?.items?.[step.id]?.[option.id]?.['qty'] - 1]
                    ?.price || 0;
              } else {
                if (itemCustomization?.items?.[step.id]?.[option.id]?.['qty']) {
                  extraPrice +=
                    (option?.price || 0) *
                    Number(itemCustomization?.items?.[step.id]?.[option.id]?.['qty'] || 0);
                }
              }
            }
          }

          items.push({
            id: productObj?.id,
            name: productObj?.name || productObj?.title,
            basePrice: basePrice || 0,
            extraPrice: extraPrice || 0,
          });
        }

        if ((items[0]?.basePrice || 0) == (items[1]?.basePrice || 0)) {
          items.sort(
            (item1, item2) =>
              item2.basePrice + item2.extraPrice - (item1.basePrice + item1.extraPrice)
          );
        } else {
          items.sort((item1, item2) => item2.basePrice - item1.basePrice);
        }

        bogoPrice = items[0].basePrice || 0;
        for (let item of items) {
          bogoPrice += item.extraPrice || 0;
        }
      }

      let productInfo =
        productsMap[newProductCust?.additionalInfo?.selectedBundleId || newProductCust?.id];
      let finalBundlePrice = 0;

      const productBasePrice =
        productInfo?.price >= 0
          ? productInfo?.price
          : productInfo?.specialPrice || productInfo?.originalPrice || 0;

      finalBundlePrice += productBasePrice;

      // add prices for extra items in bundle
      let productSteps;
      if (productsMap[mainProductId]?.bundleTypeId == 'bundle_group') {
        const optionId = parseInt(locationSearch.get('option'));

        let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
          let itemInfo;
          if (!item?.id) {
            itemInfo = productsMap[item];
          } else {
            itemInfo = item;
          }

          return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
        });

        if (!bgSteps?.id) {
          bgSteps = productsMap[bgSteps];
        }

        if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
          bgSteps = productsMap[bgSteps?.id];
        }

        productSteps = bgSteps?.steps;
      } else {
        productSteps = productsMap[mainProductId]?.steps;
      }

      for (let [stepId, step] of Object.entries(
        newProductCust?.['items'] || newProductCust?.['bundle'] || {}
      )) {
        let stepInfo = productSteps?.find((stepObj) => stepObj?.id == stepId);
        if (!stepInfo || stepInfo?.isHidden == 1) {
          continue;
        }

        for (let [itemId, itemInfo] of Object.entries(step || {})) {
          if (!itemInfo?.notAdded) {
            let selectedOption = stepInfo?.options?.find((option) => option?.id == itemId);

            // calculate price for pizza
            if (selectedOption?.typeId == 'configurable') {
              let extraItemPrice = 0;
              let itemVariationArray = [-1, -1, -1];

              if (Object.values(itemInfo?.variants || {}).length > 0) {
                Object.values(itemInfo?.variants || {}).forEach((variant, index) => {
                  itemVariationArray[index] = variant;
                });
              } else {
                Object.values(selectedOption?.variants || {}).forEach((variant, index) => {
                  const selection = variant?.options?.find((option) => option?.isSelected == 1);
                  if (selection) {
                    itemVariationArray[index] = selection?.id;
                  }
                });
              }
              let selectedItem = selectedOption?.items?.find((item) => {
                let isVariantSame = true;
                itemVariationArray.forEach((variant, index) => {
                  if (item[`sel${index + 1}Value`] != variant) {
                    isVariantSame = false;
                  }
                });
                return isVariantSame;
              });

              if (!selectedItem?.id) {
                selectedItem = productsMap[selectedItem];
              }

              extraItemPrice +=
                (selectedItem?.price >= 0
                  ? selectedItem?.price
                  : selectedItem?.specialPrice || selectedItem?.originalPrice) || 0;

              // add price of items
              for (let [itemStepId, itemStepInfo] of Object.entries(itemInfo?.items || {})) {
                let currentStep = selectedItem?.steps?.find((s) => s.id == itemStepId);

                for (let [itemInfoId, itemInfoObj] of Object.entries(itemStepInfo || {})) {
                  let itemDetails = currentStep?.options?.find((op) => op?.id == itemInfoId);
                  if (itemDetails?.subOptions) {
                    extraItemPrice +=
                      itemDetails?.subOptions[(itemInfoObj?.qty || 1) - 1]?.price || 0;
                  } else {
                    extraItemPrice +=
                      (itemDetails?.price || 0) *
                      ((itemInfoObj?.qty || 1) - itemDetails?.selectionQty);
                  }
                }
              }
              finalBundlePrice += extraItemPrice;
            } else {
              let prodPrice =
                (selectedOption?.price >= 0
                  ? selectedOption?.price
                  : selectedOption?.specialPrice || selectedOption?.originalPrice) || 0;

              prodPrice = prodPrice * itemInfo?.qty;
              finalBundlePrice += prodPrice;
            }
          }
        }
      }

      dispatch(
        updateProductPayload({
          data: {
            ...newProductCust,
            price: productsMap[mainProductId]?.isBOGO
              ? bogoPrice * parseFloat(newProductCust['qty'] || 1)
              : finalBundlePrice * parseFloat(newProductCust['qty'] || 1),
            additionalInfo: { ...(newProductCust?.additionalInfo || {}), ...qtyInfo },
          },
        })
      );
      const replace = locationSearch.has('main_product') ? true : false;
      window.localStorage.setItem('completedStep', stepId);
      // debugger;
      if (replace) {
        navigate(-1);
      } else {
        navigate(
          `${location.state?.oldLocation?.state?.retUrl}${
            locationSearch.has('cartId')
              ? `?cartId=${locationSearch.get('cartId')}`
              : location.state?.oldLocation?.search || ''
          }`
        );
      }
    } else {
      if (typeof onClick === 'function') {
        onClick();
      } else {
        navigate(to || '/cart');
      }
    }
  };

  const renderPrice = () => (
    <>
      <div className={css.detail}>
        <div className={css.itemCount}>
          {1} <FormattedMessage id={'item'} defaultMessage={'ITEM'} />
        </div>
        <div
          className={classNames(
            css.priceWrapDefault,
            { [css.flexDirRow]: showCustomizeProductDialog > 0 },
            {
              [css.priceStyle]: showCustomizeProductDialog > 0,
            }
          )}
        >
          <span className={css.price}>
            {decimalChecker(amount)} {currency}
          </span>
          <span className={css.taxStyle}>
            {countryValidations?.isVatEnabled ? (
              <p>
                {' '}
                <FormattedMessage id="inclusive_of_taxes" defaultMessage="Inclusive Of Taxes" />
              </p>
            ) : (
              ''
            )}
          </span>
        </div>
      </div>
    </>
  );
  //TODO: changes on structure - add span as discussed
  return (
    <div
      className={classNames(
        css.checkoutSection,
        {
          [css.reCustomisedAddCart]: showCustomizeProductDialog > 0,
        },
        { [css.space]: !isDesktop && showCustomizeProductDialog > 0 }
      )}
      onClick={handleNavigation}
    >
      <div className={css.btnPriceDetailsWrap}>
        {!isDesktop ? (
          <div className={classNames(css.cartAmount, { [css.cartPriceWrap]: !isDesktop })}>
            <span>{decimalChecker(amount)} </span>
            <span>{currency}</span>
          </div>
        ) : (
          <>
            <div className={css.imgBox}>
              <img
                className={css.noTranslateY}
                src={imgSrc}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImg;
                }}
              />
            </div>
            {renderPrice()}
          </>
        )}
      </div>
      <div
        className={classNames(css.checkoutButton, {
          [css.btnStyle]: showCustomizeProductDialog > 0,
        })}
      >
        {/* {showCustomizeProductDialog > 0 ? <img className={css.addIconStyle} src={addIcon} /> : null} */}
        <div
          className={classNames(css.innerCont, {
            [css.whiteBg]: showCustomizeProductDialog === undefined,
          })}
        >
          {showCustomizeProductDialog > 0 && showIcon ? (
            <img
              className={classNames(css.cartBag, css.noTranslateY)}
              src={enabledCartBag}
              alt="Cart bag"
            />
          ) : null}
          <span className={css.label}>{buttonText || 'View Cart'}</span>
        </div>
      </div>
    </div>
  );
}
